/**
 * @module mapbs.components.realestateinformation.panel.realestateinformationpanel
 */
import angular from 'angular';

import './../realestateinformationpanel.scss';

import mapbsRealEstateSelectionService from 'mapbs/components/reportpanel/service/realestateselection';
import mapbsRealestateinformationService from 'mapbs/components/realestateinformation/service/mapbsRealestateinformationService';
import mapbsRealestateinformation from 'mapbs/components/realestateinformation/model/realestateinformationmodel';
import mapbsEgtsingleModal from 'mapbs/components/reportpanel/egtsingle/egtsinglemodal/egtsinglemodal.js';


const moduleRealestateinformationpanel = angular.module('mapbsRealestateinformationpanelModule', [
    mapbsRealEstateSelectionService.name,
    mapbsRealestateinformationService.name,
    mapbsEgtsingleModal.name,
]);

moduleRealestateinformationpanel.run(
    /* ngInject */($templateCache) => {
        $templateCache.put('mapbs/realestateinformationpanel', require('./realestateinformationpanel.html'));
    }
);

/** @type {!angular.Component} */
const RealestateinformationpanelComponent = {
    controller: 'mapbsRealestateinformationpanelController as ctrl',
    templateUrl: 'mapbs/realestateinformationpanel',
    bindings: {
        'egrid': '=realestatePanelEgrid',
        'showEgtModal': '=realestatePanelShowEgtModal',
        'egtRealEstate': '=realestatePanelRealEstate',
        'selectedFeatures': '<selectedFeatures'
    },
};

moduleRealestateinformationpanel.component('mapbsRealestateinformationpanel', RealestateinformationpanelComponent);

class RealestateinformationpanelController {
    /**
   * @constructor
   * @param {angular.Scope} $scope
   * @param {angular.$injector} $injector
   * @param {ngeo.statemanager.Location} ngeoLocation ngeo Location service.
   * @param {ngeo.ToolActivateMgr} ngeoToolActivateMgr
   * @param {mapbsRealestateinformationService} mapbsRealestateinformationService
   * @param {mapbs.RealEstateSelectionService} mapbsRealEstateSelectionService

   * @ngInject
   */
    constructor($scope, $http, $injector, ngeoToolActivateMgr, mapbsRealestateinformationService, mapbsRealEstateSelectionService) {
        /**
         * @param {angular.Scope}
         * @private
         */
        this.scope = $scope;

        this.http = $http;

        this.realestateInformationService = mapbsRealestateinformationService;

        this.realEstateSelectionService = mapbsRealEstateSelectionService;

        this.realEstate = new mapbsRealestateinformation();

        /** @type {string} @private */
        this.baseurl = $injector.get('ngeoEgtBase');

        /** @type {string} */
        this.state = null;

        /** @type {string} */
        this.info = null;

        /** @type {string} */
        this.egrid = null;

        /** @type {boolean} */
        this.buildingsVisible = true;

        /** @type {boolean} */
        this.realestatePanelActive = false;

        this.selectedFeatures = null;

        /** @type {boolean} */
        this.showEgtModal = false;

        /** @type {boolean} */
        this.showCaptcha = false;

        this.scope.$watch(
            () => {
                return this.egrid;
            },
            (newVal) => {
                if (newVal) {
                    this.setState('loading');
                    this.getRealestateInformation(newVal);
                }
            }
        );
    }

    /**
  * @param {string} egrid
  * @returns {angular.$q.Promise<any>}
  */

    async getRealestateInformation(egrid) {
        const data = await this.realestateInformationService.getRealestateInfo(egrid);
        if (data.status === 200){
            const jsonObj = await data.json();
            this.realEstate.getRealestateInfoObject(jsonObj['RealEstates'][0]);
            this.egtRealEstate = {...this.realEstate};
            this.setState('inactive');
            this.scope.$apply();
        }
        else if(data.status === 406){
            this.setState('notAcceptable');
        }
        else {
            this.setState('error');
        }

    }

    unselectBuildingOnMap(buildingId) {
        const building = this.realEstate.buildings.find(b => b.buildingId === buildingId);
        if (building) {
            this.selectedFeatures.remove(building.geometry);
        }
    }
    selectBuildingOnMap(buildingId) {
        const building = this.realEstate.buildings.find(b => b.buildingId === buildingId);
        if (building) {
            this.selectedFeatures.push(building.geometry);
        }
    }

    toggleBuilding(id) {
        const elemid = `building-${id}`;
        const elementItem = document.getElementById(elemid);
        const isOpen = elementItem.style.display === 'block';

        if (isOpen) {
            this.unselectBuildingOnMap(id);
        }
        else {
            this.selectBuildingOnMap(id);
        }

        this.toggleListView(elemid);
    }

    toggleListView(elemid) {
        const elementItem = document.getElementById(elemid);
        const elementCaret = document.getElementById(`buildings-toggle-icon-${elemid}`);
        const isOpen = elementItem.style.display === 'block';

        if (isOpen) {
            elementCaret.classList.remove('caret');
            elementCaret.classList.add('caret-left');
            elementItem.style.display = 'none';

        } else {
            elementCaret.classList.remove('caret-left');
            elementCaret.classList.add('caret');
            elementItem.style.display = 'block';
        }
    }

    addressesOnRE(item){
        return item.containedByRealEstate;
    }

    addressesOutsideRE(item){
        return !item.containedByRealEstate;
    }

    /**
     * @private
     */
    setState(state) {
        this.state = state;
    }

    /**  @private  */
    openEgtModal() {
        this.showEgtModal = !this.showEgtModal;

    }


}
moduleRealestateinformationpanel.controller('mapbsRealestateinformationpanelController', RealestateinformationpanelController);

export default moduleRealestateinformationpanel;
